import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  defaultResponse,
  TokenValidationResponse,
} from 'src/app/models/csi-http.model';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class CsiService {
  private isNeptune = new BehaviorSubject<boolean>(false);
  public isNeptune$ = this.isNeptune.asObservable();

  constructor(private http: HttpClient) {}

  validateToken(token: string): Observable<TokenValidationResponse> {
    const url = `${environment.apiURL}/rest/public/customer-experience/validation?token=${token}`;
    return this.http.get<TokenValidationResponse>(url).pipe(
      tap((response: TokenValidationResponse) => {
        const isNeptune = response.storeGroup.some(
          (group) => group === 'NEPTUN'
        );
        this.isNeptune.next(isNeptune);
      })
    );
  }

  postAnswers(
    answers: any,
    nps: number,
    feedback: string,
    token: string
  ): Observable<defaultResponse<string>> {
    const payload = {
      formToken: token,
      nps: nps,
      formId: environment.formId,
      csiDTOList: answers,
      surveyDTOList: [
        {
          questionNumber: 1,
          answer: feedback,
        },
      ],
    };
    const url = `${environment.apiURL}/rest/public/customer-experience/invoice`;
    return this.http.post<defaultResponse<string>>(url, payload);
  }
}
